import { Layout } from 'antd';
import Footer from './Footer';
import PublicHeader from './Headers/Public';

const { Content } = Layout;

const PublicLayout = ({ global, children }) => {
    if (!global) {
        return children;
    }

    return (
        <Layout className="public-layout">
            <Layout className="app-body">
                <PublicHeader />

                <Layout className="app-content-wrapper">
                    <Content className="app-content">
                        {children}
                        <Footer />
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default PublicLayout;